import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import ElementLocale from 'element-ui/lib/locale';
import ElementUI from 'element-ui'

var name = "lang";
// URL参数中带有语言参数
var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
var r = window.location.search.substr(1).match(reg);
var lang = r != null ? decodeURIComponent(r[2]) : "";
//console.log(lang,"===lang===lang===")
let lang_arr = {
  "zh": "zh-cn", "tw": "zh-tw", "ar": "ar-ab", "de": "de-de", "en": "en-us", "es": "es-la", "fr": "fr-fr",
  "in": "in-do", "it": "it-it", "ja": "ja-jp", "pt": "pt-pt", "ru": "ru-ru", "ko": "ko-re"
};
if (!lang) {
  // 从本地存储获取
  lang = localStorage.getItem('locale');
}
let navLang_arr = []
if(lang){
  // 验证语言
  navLang_arr = lang.split("-");
  if (navLang_arr[1] && lang_arr[navLang_arr[1]]) {
    lang = lang_arr[navLang_arr[1]];
  } else if (lang_arr[navLang_arr[0]]) {
    lang = lang_arr[navLang_arr[0]];
  }else{
    lang = '';
  }
  localStorage.setItem('locale', lang);
}
if (!lang) {
  // 从浏览器头中获取
  let navLang = navigator.language.toLowerCase();
  navLang_arr = navLang.split("-");
  if (navLang_arr[1] && lang_arr[navLang_arr[1]]) {
    lang = lang_arr[navLang_arr[1]];
  } else if (lang_arr[navLang_arr[0]]) {
    lang = lang_arr[navLang_arr[0]];
  } else {
    lang = 'zh-cn'
  }
  localStorage.setItem('locale', lang);
}
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1];
      const EleLocaleMsg = ['zh-cn', 'zh-tw'].indexOf(locale) > -1 ? zhLocale : enLocale;
      messages[locale] = {
        ...locales(key),
        ...EleLocaleMsg
      }
    }
  })
  return messages
}

// 在这里修改 默认语言和备选语言  默认是中文
const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: lang,
  messages: loadLocaleMessages(),
  silentTranslationWarn: true
})

Vue.use(ElementUI, {i18n:(key, value) => i18n.t(key, value)})
export default i18n;